import React, { useState, useEffect } from 'react';
import { Save, RefreshCw } from 'lucide-react';
import { adminAPI } from '../lib/api';

const AdminComposantesTURPE = () => {
  const [composantes, setComposantes] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [dataSource, setDataSource] = useState('default');

  const TENSIONS = [
    { id: 'HTA', label: 'HTA (Haute Tension)' },
    { id: 'BTSUP', label: 'BTSUP (BT > 36 kVA)' },
    { id: 'BTINF', label: 'BTINF (BT < 36 kVA)' }
  ];

  const CONTRATS = [
    { id: 'CARD', label: 'CARD' },
    { id: 'Unique', label: 'Unique' }
  ];

  const COMPOSANTES_COLS = [
    { id: 'cg', label: 'CG (€/an)', description: 'Composante Gestion' },
    { id: 'cc', label: 'CC (€/an)', description: 'Composante Comptage' },
    { id: 'cacnc_socle', label: 'CACNC socle (€/an)', description: 'Soutirage' },
    { id: 'cacnc_maj', label: 'CACNC maj (€/an)', description: 'Majoration' },
    { id: 'ct', label: 'CT (€/kVA)', description: 'Composante Transit' },
    { id: 'cer', label: 'CER (c€/kVArh)', description: 'Énergie Réactive' },
    { id: 'cta_taux', label: 'Taux CTA (%)', description: 'Contribution Tarifaire' },
    { id: 'cmdps_formule', label: 'CMDPS α', description: 'Coefficient dépassement' }
  ];

  useEffect(() => {
    loadComposantes();
  }, []);

  const loadComposantes = async () => {
    setLoading(true);
    try {
      const response = await adminAPI.getComposantesTURPE();
      const { data, source } = response.data;
      setComposantes(data);
      setDataSource(source);
    } catch (error) {
      console.error('Erreur chargement composantes:', error);
      // Charger les valeurs par défaut en cas d'erreur
      loadDefaultComposantes();
    } finally {
      setLoading(false);
    }
  };

  const loadDefaultComposantes = () => {
    // Charger depuis Excel TURPE7
    const defaultComposantes = {
      'HTA_CARD': { cg: 499.8, cc: 376.39, cacnc_socle: 0, cacnc_maj: 0, ct: 0, cer: 2.44, cta_taux: 15, cmdps_formule: 0.04 },
      'HTA_Unique': { cg: 435.72, cc: 376.39, cacnc_socle: 0, cacnc_maj: 0, ct: 0, cer: 2.44, cta_taux: 15, cmdps_formule: 0.04 },
      'BTSUP_CARD': { cg: 249.84, cc: 283.27, cacnc_socle: 0, cacnc_maj: 0, ct: 0, cer: 0, cta_taux: 15, cmdps_formule: 12.41 },
      'BTSUP_Unique': { cg: 217.8, cc: 283.27, cacnc_socle: 0, cacnc_maj: 0, ct: 0, cer: 0, cta_taux: 15, cmdps_formule: 12.41 },
      'BTINF_CARD': { cg: 18, cc: 22, cacnc_socle: 38.88, cacnc_maj: 24.84, ct: 0, cer: 0, cta_taux: 15, cmdps_formule: 0 },
      'BTINF_Unique': { cg: 16.8, cc: 22, cacnc_socle: 38.88, cacnc_maj: 24.84, ct: 0, cer: 0, cta_taux: 15, cmdps_formule: 0 }
    };
    
    setComposantes(defaultComposantes);
  };

  const updateComposante = (tension, contrat, composante, valeur) => {
    const key = `${tension}_${contrat}`;
    const newComposantes = { ...composantes };
    if (!newComposantes[key]) newComposantes[key] = {};
    newComposantes[key][composante] = parseFloat(valeur) || 0;
    setComposantes(newComposantes);
    setHasChanges(true);
  };

  const handleSave = async () => {
    if (!window.confirm('Enregistrer les composantes TURPE ?')) return;
    
    setSaving(true);
    try {
      await adminAPI.updateComposantesTURPE(composantes);
      alert('Composantes sauvegardées !');
      setHasChanges(false);
      setDataSource('database');
    } catch (error) {
      console.error('Erreur sauvegarde:', error);
      alert(error.response?.data?.detail || 'Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-4xl font-heading font-semibold text-[#191D1E] tracking-tight">
            Composantes Fixes TURPE
          </h1>
          <p className="text-[#687175] mt-2">
            Gestion des composantes par domaine de tension et type de contrat
          </p>
        </div>
        <div className="flex gap-3">
          {hasChanges && (
            <button onClick={() => window.location.reload()} className="flex items-center gap-2 border border-[#BFC6CC] text-[#687175] px-4 py-2 rounded-lg">
              <RefreshCw className="w-4 h-4" /> Annuler
            </button>
          )}
          <button onClick={handleSave} disabled={!hasChanges || saving} className="flex items-center gap-2 bg-[#397DFF] hover:bg-[#4672B6] text-white px-6 py-3 rounded-lg disabled:opacity-50">
            <Save className="w-5 h-5" /> {saving ? 'Sauvegarde...' : 'Enregistrer'}
          </button>
        </div>
      </div>

      {hasChanges && (
        <div className="mb-6 p-4 bg-[#F9C80E]/10 border border-[#F9C80E] rounded-lg">
          <p className="text-sm text-[#191D1E]">⚠️ Modifications non enregistrées</p>
        </div>
      )}

      {/* Tableau unique avec sous-colonnes par tension */}
      <div className="bg-white border border-[#BFC6CC] rounded-lg overflow-hidden">
        <div className="bg-[#397DFF] text-white px-6 py-3">
          <h3 className="font-semibold text-lg">Composantes Fixes par Tension et Contrat</h3>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-[#F5F6F9]">
              <tr>
                <th rowSpan="2" className="px-4 py-3 text-left text-sm font-semibold text-[#191D1E] border-r-2 border-[#397DFF]">
                  Tension
                </th>
                <th rowSpan="2" className="px-4 py-3 text-left text-sm font-semibold text-[#191D1E] border-r border-[#BFC6CC]">
                  Contrat
                </th>
                {COMPOSANTES_COLS.map((comp) => (
                  <th key={comp.id} className="px-3 py-2 text-center text-xs font-semibold text-[#191D1E] border-l border-[#BFC6CC]">
                    <div>{comp.label}</div>
                    <div className="text-[#687175] font-normal text-[10px]">{comp.description}</div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-[#BFC6CC]">
              {TENSIONS.map((tension) => (
                CONTRATS.map((contrat, idx) => {
                  const key = `${tension.id}_${contrat.id}`;
                  const isFirstRow = idx === 0;
                  
                  return (
                    <tr key={key} className={`hover:bg-[#F5F6F9] ${isFirstRow ? 'border-t-2 border-[#397DFF]' : ''}`}>
                      {isFirstRow && (
                        <td rowSpan={CONTRATS.length} className="px-4 py-3 font-semibold text-[#191D1E] bg-[#F5F6F9] border-r-2 border-[#397DFF]">
                          {tension.label}
                        </td>
                      )}
                      <td className="px-4 py-3 text-sm text-[#687175] border-r border-[#BFC6CC]">
                        {contrat.label}
                      </td>
                      {COMPOSANTES_COLS.map((comp) => (
                        <td key={comp.id} className="px-1 py-1 border-l border-[#BFC6CC]">
                          <input
                            type="number"
                            step={comp.id === 'cer' ? '0.01' : '0.01'}
                            value={composantes[key]?.[comp.id] || ''}
                            onChange={(e) => updateComposante(tension.id, contrat.id, comp.id, e.target.value)}
                            className="w-full px-2 py-2 text-center border-0 focus:ring-2 focus:ring-[#397DFF] font-mono text-xs"
                            placeholder="0.00"
                          />
                        </td>
                      ))}
                    </tr>
                  );
                })
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="mt-6 p-4 bg-[#E8F4FD] border border-[#397DFF] rounded-lg text-sm text-[#687175]">
        <strong className="text-[#191D1E]">Légende :</strong><br/>
        CG = Gestion | CC = Comptage | CACNC = Soutirage | CT = Transit | CER = Énergie Réactive<br/>
        <strong>Taux CTA</strong> = 15% de (CS fixe + CC) | <strong>CMDPS HTA</strong> = 0,04 × b × √(Σ ΔP²) | <strong>CMDPS BTSUP</strong> = 12,41 × h
      </div>
    </div>
  );
};

export default AdminComposantesTURPE;
